class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header");

    this.setHeaderHeight();

    window
      .matchMedia("(max-width: 60em)")
      .addEventListener("change", this.setHeaderHeight.bind(this));

    this.header.classList.add("shopify-section-header-sticky");
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }
}
customElements.define("sticky-header", StickyHeader);
